import type { IDynamicCliffExponential } from "../dynamic/CliffExponential";
import type { IDynamicExponential } from "../dynamic/Exponential";
import type { IDynamicStepper } from "../dynamic/Stepper";
import type { IDynamicTimelock } from "../dynamic/Timelock";
import type { IDynamicUnlockCliff } from "../dynamic/UnlockCliff";
import type { IDynamicUnlockLinear } from "../dynamic/UnlockLinear";
import type { ICliff } from "../linear/Cliff";
import type { ILinear } from "../linear/Linear";
import { extension as DynamicCliffExponential } from "../dynamic/CliffExponential";
import { extension as DynamicExponential } from "../dynamic/Exponential";
import { extension as DynamicStepper } from "../dynamic/Stepper";
import { extension as DynamicTimelock } from "../dynamic/Timelock";
import { extension as DynamicUnlockCliff } from "../dynamic/UnlockCliff";
import { extension as DynamicUnlockLinear } from "../dynamic/UnlockLinear";
import { extension as Cliff } from "../linear/Cliff";
import { extension as Linear } from "../linear/Linear";
import { Extension, IConfiguration } from "./setup";

//the order her matters. Please check the identify for the explanation
const config: { [key: Extension]: IConfiguration } = {
  [Extension.CLIFF]: Cliff,
  [Extension.LINEAR]: Linear,
  [Extension.DYNAMIC_TIMELOCK]: DynamicTimelock,
  [Extension.DYNAMIC_UNLOCK_LINEAR]: DynamicUnlockLinear,
  [Extension.DYNAMIC_UNLOCK_CLIFF]: DynamicUnlockCliff,
  [Extension.DYNAMIC_CLIFF_EXPONENTIAL]: DynamicCliffExponential,
  [Extension.DYNAMIC_STEPPER]: DynamicStepper,
  [Extension.DYNAMIC_EXPONENTIAL]: DynamicExponential,
};

const baseStream = {
  alias: "",
  id: "",
  canceled: false,
  proxied: true,
  contract: {
    address: "",
  },
  sender: "",
  recipient: "",
  proxender: "",
  withdrawnAmount: "0",
  segments: [],
};

type IExtensionForm =
  | ICliff
  | ILinear
  | IDynamicCliffExponential
  | IDynamicExponential
  | IDynamicStepper
  | IDynamicTimelock
  | IDynamicUnlockLinear
  | IDynamicUnlockCliff;

const linear: Extension[] = [Extension.LINEAR, Extension.CLIFF];
const dynamic: Extension[] = [
  Extension.DYNAMIC_EXPONENTIAL,
  Extension.DYNAMIC_CLIFF_EXPONENTIAL,
  Extension.DYNAMIC_STEPPER,
  Extension.DYNAMIC_TIMELOCK,
  Extension.DYNAMIC_UNLOCK_LINEAR,
  Extension.DYNAMIC_UNLOCK_CLIFF,
];

export type { IExtensionForm };
export { linear, dynamic, baseStream };
export default config;
